import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { isEmpty } from "lodash";

import Loader from "@amzn/meridian/loader";
import Row from "@amzn/meridian/row";

import { ENABLE_MAP_UPLOAD } from "app-constants";
import MapContainer from "componentsV2/MapPage/MapContainer";
import MapCreationHandler from "./MapCreationHandler";

export default function MapPageBody({ yardId }) {
  const { yardMap, fetchingYardMap } = useSelector((state) => state.yardMapData);
  const featureFlags = useSelector((state) => state.featureFlags);

  if (isEmpty(yardMap)) {
    if (fetchingYardMap || !featureFlags[ENABLE_MAP_UPLOAD]?.enabled) {
      return (
        <Row data-testid="fetchYardMapLoader" spacingInset="medium" alignmentHorizontal="center">
          <Loader />
        </Row>
      );
    } else {
      return <MapCreationHandler yardId={yardId} />;
    }
  }

  return <MapContainer yardId={yardId} />;
}

MapPageBody.propTypes = {
  yardId: PropTypes.string.isRequired,
};
